import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './stylesheet/styles.scss'
import './libs/i18n/i18n.helper'
// import * as serviceWorker from './serviceWorker'

// stg・prdではmswは無効
const isMockableEnvironment =
  process.env.REACT_APP_ENVIRONMENT !== 'stg' &&
  process.env.REACT_APP_ENVIRONMENT !== 'stg2' &&
  process.env.REACT_APP_ENVIRONMENT !== 'prd'

const main = async (): Promise<void> => {
  if (isMockableEnvironment && process.env.REACT_APP_MOCK_TOL_OPERATIONS === 'true') {
    const { startMockServer } = await import('./mocks')
    await startMockServer()
  }

  ReactDOM.render(<App />, document.getElementById('root'))
}

void main()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()
